module.exports = {"libs.constants.noticeMessage.noticeShowContact":"Si sigues viendo este error, contáctanos en https://choosemuse.com/contactsupport","libs.constants.noticeMessage.general":"Lo sentimos, algo salió mal. Por favor intenta nuevamente.","libs.constants.sessionTimeout.notificationMessage":"La sesión se cerró debido a la inactividad. Inicia sesión en tu cuenta para continuar la sesión.","libs.constants.auth.notificationMessage":"Debes registrarte primero"}


//////////////////
// WEBPACK FOOTER
// ./src/i18n/es/libs/constants.json
// module id = 766
// module chunks = 0